import React, { FC } from 'react'
import { Modal, ModalProps } from '../../Modal'
import { QRScannerModalContent } from './content'
import { useAppDispatch } from '../../../app/hooks'
import { handleQRScannerModal } from '../../../features/modals/modalsSlice'


export const QRScannerModal: FC<ModalProps> = ({ opened, level }) => {
    const dispatch = useAppDispatch()

    const handleModal = () => {
        dispatch(handleQRScannerModal())
    }

    return (
        <Modal opened={opened}>
          <QRScannerModalContent level={level} handleModal={handleModal} />
        </Modal>
    )
}
